import { render, staticRenderFns } from "./SocialUpload.vue?vue&type=template&id=fff08cb8&scoped=true"
import script from "./SocialUpload.vue?vue&type=script&lang=js"
export * from "./SocialUpload.vue?vue&type=script&lang=js"
import style0 from "./SocialUpload.vue?vue&type=style&index=0&id=fff08cb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff08cb8",
  null
  
)

export default component.exports